import { FC, useState, useCallback } from 'react';
import { ChevronDownIcon, FlagIcon, LocationIcon, SearchIcon, TitleResourceCenter, PlusIcon, SortByIcon } from 'assets/images/resourceCenter';
import { Modal } from 'src/common';
import { Resource, ResourceCard, ResourceType } from './ResourceCard';
import { MobileFilterMenu } from './MobileFilterMenu';
import { ResourceFolderItem } from './ResourceFolder';
import { useStyles } from './ResouceCenter.styles';
import { MyVoice, PositiveMindset, ProfileDarrell, ProfileJustin, YouthMusicProject, YouthMusicProject2 } from './ResourceCard/exampleImages';
import { AddResource } from './AddResource';

interface ResourceFolders {
  color: string;
  countResources: number;
  id: string;
  name: string;
}

const resourceFolders: ResourceFolders[] = [
  {
    id: 'folder-1',
    name: 'Mylee’s Resources',
    color: '#ECBAAE',
    countResources: 3,
  },
  {
    id: 'folder-2',
    name: 'Personal',
    color: '#B88F5E',
    countResources: 15,
  },
  {
    id: 'folder-3',
    name: 'Photography',
    color: '#B8C8A4',
    countResources: 4,
  },
  {
    id: 'folder-4',
    name: 'My Submissions',
    color: '#D8D8D8',
    countResources: 3,
  },
];

const allResources: Resource[] = [
  {
    id: 'res-1',
    name: 'Darrell Grant',
    description: 'Darrell Grant is a professional jazz pianist located in Portland, Oregon.',
    image: ProfileDarrell,
    isProfile: true,
    type: ResourceType.Person,
    tag: 'musician',
  },
  {
    id: 'res-2',
    name: 'My Voice Music',
    description:
      'MVM Studios is a full recording studio for emerging songwriters, musicians, beat makers, and poets ages 9-24. At MVM Studios we offer various classes, workshops, and long-term mentorships',
    image: MyVoice,
    isProfile: false,
    type: ResourceType.People,
    tag: 'nonprofit',
  },
  {
    id: 'res-3',
    name: 'Youth Music Project',
    description:
      'Youth Music Project is a nonprofit 501(c)(3) organization that offers Group and Private Music lessons and provides students with sophisticated, state-of-the-art performance and recording opportunities.',
    image: YouthMusicProject,
    isProfile: false,
    type: ResourceType.People,
    tag: 'nonprofit',
  },
  {
    id: 'res-4',
    name: 'Positive Mindset Tips',
    description:
      'Youth Music Project is a nonprofit 501(c)(3) organization that offers Group and Private Music lessons and provides students with sophisticated, state-of-the-art performance and recording opportunities.',
    image: PositiveMindset,
    isProfile: false,
    type: ResourceType.Info,
    tag: 'article',
  },
  {
    id: 'res-5',
    name: 'Youth Music Project',
    description:
      'Youth Music Project is a nonprofit 501(c)(3) organization that offers Group and Private Music lessons and provides students with sophisticated, state-of-the-art performance and recording opportunities.',
    image: YouthMusicProject2,
    isProfile: false,
    type: ResourceType.Info,
    tag: 'article',
  },
  {
    id: 'res-6',
    name: 'Justin Thomas',
    description: 'Justin Thomas is a photographer who specializes in high contrast black and grey portraits.',
    image: ProfileJustin,
    isProfile: true,
    type: ResourceType.Person,
    tag: 'artist',
  },
];

export const ResourceCenter: FC = () => {
  const styles = useStyles();
  const [isModalOpen, setModalState] = useState(false);
  const toggleModal = useCallback(() => {
    setModalState(!isModalOpen);
  }, [isModalOpen]);

  return (
    <div>
      <div className={styles.containerHeader}>
        <div className={styles.containerLeftButtonsNavHeader}>
          <img src={LocationIcon} alt="location-icon" className={styles.locationIcon} />
          <span className={styles.titleLocation}>Portland, OR</span>
          <img src={ChevronDownIcon} alt="chevron-down-icon" className={styles.chevronDownIcon} />
        </div>
        <div className={styles.containerTitleResourceCenter}>
          <img src={TitleResourceCenter} alt="title-resource-center" className={styles.titleResourceCenter} />
        </div>
        <div className={styles.containerRightButtonsNavHeader}>
          <button type="button" className={styles.searchButton}>
            <img src={SearchIcon} alt="flag-icon" className={styles.searchIcon} />
          </button>
          <button type="button" className={styles.flagButton}>
            <img src={FlagIcon} alt="flag-icon" className={styles.flagIcon} />
          </button>
          <button type="button" className={styles.buttonAddResource} onClick={toggleModal}>
            <span className={styles.titleButtonAddResource}>Add a Resource</span>
          </button>
          <button type="button" className={styles.plusButton} onClick={toggleModal}>
            <img src={PlusIcon} alt="plus-icon" className={styles.plusIcon} />
          </button>
          <Modal isOpen={isModalOpen} onClose={toggleModal} title="Add a Resource">
            <AddResource name="Anyi" />
          </Modal>
        </div>
      </div>
      <div className={styles.containerContent}>
        <span className={styles.title}>My Toolbox</span>
        <div className={styles.wrapperQuickAccess}>
          <span className={styles.titleQuickAccess}>Have quick access to your favorite Resources</span>
          <div className={styles.wrapperQuickAccessButtons}>
            <button type="button" className={styles.buttonsQuickAccess}>
              <span className={styles.titleButtonsQuickAccess}>Sort By</span>
              <img src={SortByIcon} alt="sort-icon" className={styles.sortByIcon} />
            </button>
            <button type="button" className={styles.buttonsQuickAccess}>
              <img src={PlusIcon} alt="plus-icon" className={styles.createNewFolderIcon} />
              <span className={styles.titleButtonsQuickAccess}>Create New Folder</span>
            </button>
            <button type="button" className={styles.buttonsQuickAccess}>
              <span className={styles.titleButtonsQuickAccess}>Select</span>
            </button>
          </div>
          <MobileFilterMenu />
        </div>
        <div className={styles.divider} />
        <div className={styles.containerFolders}>
          {resourceFolders.map((rf) => (
            <ResourceFolderItem key={rf.id} name={rf.name} count={rf.countResources} color={rf.color} />
          ))}
        </div>
        <span className={styles.titleAllResources}>All Resources</span>
        <div className={styles.containerAllResources}>
          {allResources.map((resource) => (
            <ResourceCard key={resource.id} item={resource} />
          ))}
        </div>
      </div>
    </div>
  );
};
